import { render } from "./OrganizationEditor.vue?vue&type=template&id=1588bbc8&scoped=true&ts=true"
import script from "./OrganizationEditor.vue?vue&type=script&lang=ts"
export * from "./OrganizationEditor.vue?vue&type=script&lang=ts"

import "./OrganizationEditor.vue?vue&type=style&index=0&id=1588bbc8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1588bbc8"]])

export default __exports__